/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import '../../config';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import ls from 'local-storage';
import _ from 'lodash';
import LinearProgress from '@material-ui/core/LinearProgress';
import OlsBottomNav from '../../container/OlsBottomNav/OlsBottomNav';
import Divider from '@material-ui/core/Divider';
import OlsFooter from '../../component/OlsFooter/OlsFooter';
import OlsNavbarAkun from '../../component/OlsNavbar/OlsNavbarAkun';
import UsrAlamatLengkap from '../../container/UsrAlamatLengkap/UsrAlamatLengkap';
import UsrRealname from '../../component/OlsRow/UsrRealname';
import UsrChangePassword from '../../component/OlsRow/UsrChangePassword';
import UsrWhatsApp from '../../component/OlsRow/UsrWhatsApp';
import UsrPoint from '../../component/OlsRow/UsrPoint';
import UsrQRCode from '../../component/OlsRow/UsrQRCode';
import UsrLogout from '../../component/OlsRow/UsrLogout';

let isMounted = false;

const useStyles = (theme) => ({
  displayMobile: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  displayDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  page: {
    backgroundColor : theme.palette.color.background,
    maxWidth: theme.palette.width.appWidth,
    paddingTop: 62,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  loadingTop: {
    height: 5,
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 'auto',
    right: 'auto',
    paddingRight: '0px !important',
    zIndex: 1101,
  },
  content: {
    padding: 4,
    display: 'block',
    minHeight: 1000,
    '&::after': {
      content: '""',
      clear: 'both',
      display: 'table',
    },
  },
});

let base_url  = global.config.host;
if(base_url.length<1){
    base_url  = window.location.origin;
}
const { pathname }  = window.location;
const arrPath       = pathname.split('/');
let urlid = (arrPath && arrPath.length >= 2) ? arrPath[2] : '';
ls.set('urlid', urlid);

class Akun extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usr_info: ls.get('usr_info') || false,
      otl_info: ls.get(`${urlid}_info`) || {},
      order_info: ls.get(`${urlid}_ShoppingCart_OrderInfo`) || {},
      item_list: [],
      loading: false,
    };
  }

  componentDidMount() {
    isMounted = true;
    
    urlid = ls.get('urlid') || '';
    let otl_info = ls.get(`${urlid}_info`) || {};
    this.setState({
      otl_info: otl_info
    });
    if (_.isString(otl_info.otl_name)) {
      document.title = otl_info.otl_name;
    }

    let usr_info = ls.get('usr_info') || false;
    this.setState({
      usr_info: usr_info
    });
    
    /*
    if(usr_info!==false){
      if(_.isString(usr_info.usr_uxid)){
        const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
        const lsShoppingCartItemList = `${urlid}_ShoppingCart_ItemList`;
        const orderInfo = ls.get(lsShoppingCartOrderInfo);
        if (_.isObject(orderInfo)) {
          if (_.isString(orderInfo.order_from_uxid)) {
            if(orderInfo.order_from_uxid===usr_info.usr_uxid){
              this.setState({ order_info: orderInfo });
              const itemList = ls.get(lsShoppingCartItemList);
              if (_.isArray(itemList)) {
                this.setState({ item_list: itemList });
              }
            }
          }
        }
      }
    }
    */

    this.pageInfo();
    //this.usrInfo();
    //this.otlInfo();
    //this.otlOrderInfo();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    isMounted = false;
  }

  pageInfo = () => {
    this.setState({ loading: true });
    urlid = ls.get('urlid') || '';
    const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
    const lsShoppingCartItemList  = `${urlid}_ShoppingCart_ItemList`;
    const formdatau = new FormData();
    formdatau.append('urlid', urlid);
    axios.post(base_url+'/olshop_api/page/info/', formdatau).then((response) => {
      if (isMounted) {
        this.setState({ loading: false });
        if (_.isObject(response.data.usr_info)) {
          this.setState({ usr_info: response.data.usr_info });
          ls.set('usr_info', response.data.usr_info);
        } else {
          this.setState({ usr_info: false });
          ls.set('usr_info', false);
          this.props.history.push('/login');
        }
        if (_.isObject(response.data.otl_info)) {
          urlid = response.data.otl_info.otl_urlid;
          this.setState({
            otl_info: response.data.otl_info,
          });
          ls.set('urlid', urlid);
          ls.set(`${urlid}_info`, response.data.otl_info);
        }
        if (_.isObject(response.data.order_info)) {
          const orderInfoResp = response.data.order_info;
          if (_.isString(orderInfoResp.order_uxid)) {
            this.setState({ order_info: orderInfoResp });
            ls.set(lsShoppingCartOrderInfo, orderInfoResp);
          }
        }
        if (_.isArray(response.data.item_list)) {
          const itemListResp = response.data.item_list;
          this.setState({ item_list: itemListResp });
          ls.set(lsShoppingCartItemList, itemListResp);
        }
      }
    });
  }

  usrInfo = () => {
    if (isMounted) {
      this.setState({ loading: true });
      urlid = ls.get('urlid') || '';
      const formdataui = new FormData();
      formdataui.append('urlid', urlid);
      axios.post(base_url+'/olshop_api/acc/acc_usr_info/', formdataui).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.usr_info)) {
            this.setState({ usr_info: response.data.usr_info });
            ls.set('usr_info', response.data.usr_info);
          } else {
            this.setState({ usr_info: false });
            ls.set('usr_info', false);
            this.props.history.push('/login');
          }
        }
      });
    }
  }

  otlInfo = () => {
    urlid = ls.get('urlid') || '';
    const formdatau = new FormData();
    formdatau.append('urlid', urlid);
    axios.post(base_url+'/olshop_api/otl/otl_info/', formdatau).then((response) => {
      if (isMounted) {
        if (_.isObject(response.data.otl_info)) {
          urlid = response.data.otl_info.otl_urlid;
          this.setState({
            otl_info: response.data.otl_info,
          });
          ls.set('urlid', urlid);
          ls.set(`${urlid}_info`, response.data.otl_info);
        }
      }
    });
  }

  otlOrderInfo = () => {
    urlid = ls.get('urlid') || '';
    const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
    const lsShoppingCartItemList  = `${urlid}_ShoppingCart_ItemList`;
    this.setState({ loading: true });
    const formdatao = new FormData();
    formdatao.append('urlid', urlid);
    axios.post(base_url+'/olshop_api/order/order_info/', formdatao).then((response) => {
      if (isMounted) {
        this.setState({ loading: false });
        if (_.isObject(response.data.order_info)) {
          const orderInfoResp = response.data.order_info;
          if (_.isString(orderInfoResp.order_uxid)) {
            this.setState({ order_info: orderInfoResp });
            ls.set(lsShoppingCartOrderInfo, orderInfoResp);
          }
        }
        if (_.isArray(response.data.item_list)) {
          const itemListResp = response.data.item_list;
          this.setState({ item_list: itemListResp });
          ls.set(lsShoppingCartItemList, itemListResp);
        }
      }
    });
  }

  handleShoppingCartOpen = () => {
    if (isMounted) {
      urlid = ls.get('urlid') || '';
      const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${urlid}_ShoppingCart_ItemList`;
      ls.set(lsShoppingCartOrderInfo, this.state.order_info);
      ls.set(lsShoppingCartItemList, this.state.item_list);
      this.props.history.push('/shoppingcart');
    }
  }

  handleAddressChange = (dt) => {
    if (isMounted) {
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('usr_realname', dt.usr_realname);
      formdata.append('usr_address1', dt.usr_address1);
      formdata.append('usr_address2', dt.usr_address2);
      formdata.append('usr_address3', dt.usr_address3);
      formdata.append('usr_address4', dt.usr_address4);
      formdata.append('usr_address5', dt.usr_address5);
      axios.post(base_url+'/olshop_api/acc/acc_address_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.usr_info)) {
            this.setState({ usr_info: response.data.usr_info });
            ls.set('usr_info', this.state.usr_info);
          }
        }
      });
    }
  }

  handleLocationChange = (dt) => {
    if (isMounted) {
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('usr_province_id', dt.usr_province_id);
      formdata.append('usr_province_name', dt.usr_province_name);
      formdata.append('usr_city_id', dt.usr_city_id);
      formdata.append('usr_city_name', dt.usr_city_name);
      formdata.append('usr_city_type', dt.usr_city_type);
      formdata.append('usr_subdistrict_id', dt.usr_subdistrict_id);
      formdata.append('usr_subdistrict_name', dt.usr_subdistrict_name);
      axios.post(base_url+'/olshop_api/acc/acc_location_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.usr_info)) {
            this.setState({ usr_info: response.data.usr_info });
            ls.set('usr_info', this.state.usr_info);
          }
        }
      });
    }
  }

  handleWhatsAppChange = (dt) => {
    if (isMounted) {
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('usr_whatsapp', dt.usr_whatsapp);
      axios.post(base_url+'/olshop_api/acc/acc_whatsapp_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.usr_info)) {
            this.setState({ usr_info: response.data.usr_info });
            ls.set('usr_info', this.state.usr_info);
          }
        }
      });
    }
  }

  render() {
    const { classes } = this.props;
    return (
        <div style={{ paddingBottom: 56, minHeight:1000 }} >
          <div style={this.state.usr_info ? {} : { display: 'none' }} >
            <div className={classes.page}>
                <div className={classes.displayDesktop} >
                  <div style={{ height: 5 }}>
                  </div>
                </div>

                <div style={this.state.usr_info ? {}:{ display: 'none' }} >
                  <div style={{ paddingTop:5, paddingBottom: 56 }}>
                    <div className={classes.content}>
                    <UsrRealname data={this.state.usr_info} />
                    <UsrPoint data={this.state.usr_info} />
                    <UsrQRCode data={this.state.usr_info} />
                    <UsrAlamatLengkap data={this.state.usr_info} onChange={this.handleAddressChange} />
                    <UsrWhatsApp data={this.state.usr_info} onChange={this.handleWhatsAppChange} />
                    <UsrChangePassword />
                    <UsrLogout />
                    </div>
                  </div>
                </div>
            </div>
            
            <Divider />
            <OlsFooter outlet={this.state.otl_info} />
          </div>

          <OlsNavbarAkun 
            value="akun" 
            title="Akun"
            text={this.state.otl_info.otl_name ? `Hallo ${this.state.otl_info.otl_name}` : 'Hallo'}
            outlet={this.state.otl_info} 
            itemCount={_.size(this.state.item_list)} 
            onCartClick={this.handleShoppingCartOpen} 
            />

          <div className={classes.displayMobile} >
            <OlsBottomNav value="akun" />
          </div>
          <div className={classes.loadingTop} >
            <LinearProgress style={this.state.loading ? {} : { display: 'none' }} />
          </div>
        </div>
    );
  }
}

export default withStyles(useStyles)(Akun);
